<bn-loading-overlay></bn-loading-overlay>

<h5>Taxa de juros máxima para os agentes financeiros</h5>

<a (click)="adicionarTaxaJurosMaximaAgente()" *ngIf="permissaoEdicao"><i class="fa fa-plus-circle cursor-pointer icone-adicionar"></i></a>

<div class="table-responsive">
    <table class="table table-hover">
        <thead>
        <tr>
            <th *ngIf="permissaoEdicao"></th>
            <th>Início de validade</th>
            <th>Taxa de juros mensal máxima (%)</th>
            <th *ngIf="permissaoEdicao"></th>
            <th *ngIf="permissaoEdicao"></th>
        <tr>
        </thead>
        <tbody>
        <tr *ngFor="let taxa of taxasJurosMaximaAgentes; let i = index">
            <td *ngIf="permissaoEdicao">
                <a (click)="removerTaxaJurosMaximaAgente(taxa)"><i class="fa fa-trash cursor-pointer"></i></a>
            </td>
            <td>
                <bn-datepicker name="dataInicioValidade{{i}}" [(ngModel)]="taxa.dataInicioValidade" [disabled]="!taxa.modoEdicao"></bn-datepicker>
            </td>
            <td>
                <input type="text" class="form-control" name="taxaJurosMaximaAgente{{i}}" [(ngModel)]="taxa.taxaJurosMaximaAgente" [disabled]="!taxa.modoEdicao" bnMask="DECIMAL" [casasDecimais]="2">
            </td>
            <td *ngIf="permissaoEdicao">
                <a (click)="editarTaxaJurosMaximaAgente(taxa)" *ngIf="!taxa.modoEdicao"><i class="fa fa-pencil cursor-pointer"></i></a>
                <a (click)="salvarTaxaJurosMaximaAgente(taxa)" *ngIf="taxa.modoEdicao"><i class="fa fa-check cursor-pointer"></i></a>
            </td>
            <td *ngIf="permissaoEdicao">
                <a (click)="cancelarEdicaoTaxaJurosMaximaAgente(taxa)" *ngIf="taxa.modoEdicao"><i class="fa fa-times cursor-pointer"></i></a>
            </td>
        </tr>
        </tbody>
    </table>
</div>